import { render, staticRenderFns } from "./sin_posgrado.vue?vue&type=template&id=4b30e508"
import script from "./sin_posgrado.vue?vue&type=script&lang=js"
export * from "./sin_posgrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports